import store from '@/core/store';
import { HttpClient } from './httpClient';
import { ParamsProcessor, ErrorHandler, API_ENDPOINTS, CONTENT_ENCODING_ENDPOINTS } from './apiService';

export default class BaseService {
    constructor(login, password, apiUrl, refData = 'ref', scheme) { //TODO:login, password устаревший, удалить нельзя
        this.apiUrl = apiUrl;
        this.refData = refData;
        this.scheme = scheme;
        this.initializeConfig();
        this.initializeHttpClient();
        this.initializeProcessors();
    }

    initializeConfig() {
        const server = store.getters.server('SERVER');
        const prefix = store.getters.server('PERFIX');
        this.baseUrl = server;
        if (this.scheme) {
            //eslint-disable-next-line
            this.baseUrl = server.replace(/\/[^\/]+\/$/, '/') + this.scheme + '/'
        }
        this.fullApiUrl = `${this.baseUrl}${this.apiUrl}:`;
        this.prefix = prefix;

        this.contentEncoding = this.shouldEnableContentEncoding();
    }

    initializeHttpClient() {
        const headers = {
            'Authorization': `Bearer ${localStorage.token}`,
            'Client-Type': `WEB`
        };

        this.httpClient = new HttpClient(this.baseUrl, headers);
    }

    initializeProcessors() {
        this.paramsProcessor = new ParamsProcessor(this.prefix);
    }

    shouldEnableContentEncoding() {
        return CONTENT_ENCODING_ENDPOINTS.some(
            endpoint =>
                endpoint.api_url === this.apiUrl &&
                endpoint.ref_data === this.refData
        );
    }

    async execProc(procedure, params) {
        const processedParams = this.paramsProcessor.prepareParams({
            ...params,
        });
        processedParams.procedure = procedure;
        const data = await this.httpClient.get(
            API_ENDPOINTS.PROC_EXEC,
            processedParams
        );

        return ErrorHandler.checkException(data);
    }

    async getData(params = {}) {
        const baseParams = {
            /*  format: 'json',*/
            ...params
        };

        const processedParams = this.paramsProcessor.prepareParams(baseParams);

        if (this.contentEncoding) {
            processedParams.content_encoding = 'true';
        }

        const data = await this.httpClient.get(
            `${this.apiUrl}:${this.refData}`,
            processedParams
        );

        return this.adaptation(ErrorHandler.checkException(data));
    }

    async putData(data, spec = null) {
        const endpoint = spec ?
            `${API_ENDPOINTS.UPDATE}_${spec}` :
            API_ENDPOINTS.UPDATE;

        const params = { format: 'json' };

        return await this.httpClient.put(
            `${this.apiUrl}:${endpoint}`,
            data,
            params
        );
    }

    async insertData(data, spec = null) {
        const endpoint = spec ?
            `${API_ENDPOINTS.INSERT}_${spec}` :
            API_ENDPOINTS.INSERT;

        const params = { format: 'json' };

        const response = await this.httpClient.put(
            `${this.apiUrl}:${endpoint}`,
            data,
            params
        );

        return ErrorHandler.checkException(response);
    }

    async deleteData(data) {
        return await this.httpClient.put(
            `${this.apiUrl}:${API_ENDPOINTS.DELETE}`,
            data
        );
    }

    adaptation(data) {
        // TODO: Логика адаптации данных может быть добавлена здесь
        return data;
    }

    async login(data) {
        const loginUrl = store.getters.server('LOGIN');
        return await this.httpClient.post(loginUrl, data);
    }

    async customPost(url, data) {
        let rootUrl = this.fullApiUrl.split('/sqldata')[0];
        rootUrl = rootUrl ? rootUrl : (new URL(this.fullApiUrl)).origin;
        const loginUrl = `${rootUrl}/${url}`;
        return await this.httpClient.post(loginUrl, data);
    }

    async customGet(url, data) {
        let rootUrl = this.fullApiUrl.split('/sqldata')[0];
        rootUrl = rootUrl ? rootUrl : (new URL(this.fullApiUrl)).origin;
        const loginUrl = `${rootUrl}/${url}`;
        return await this.httpClient.get(loginUrl, data);
    }

}